import { QueryClient } from "@tanstack/react-query";

export const DEFAULT_QUERY_STALE_TIME_MS = 30_000;

export function createAppQueryClient() {
  return new QueryClient({
    defaultOptions: {
      queries: {
        staleTime: DEFAULT_QUERY_STALE_TIME_MS,
      },
    },
  });
}
